"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
var Form_1 = __importDefault(require("../Form"));
var Application = /** @class */ (function () {
    function Application() {
    }
    Application.setValidationSchema = function () {
        return [
            // step 1
            yup.object().shape({
                name: yup.string()
                    .matches(/^\s*[\S]+(\s[\S]+)+\s*$/gms, Form_1.default.errorMessages.name.fullName)
                    .matches(/^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi, Form_1.default.errorMessages.name.latinOnly)
                    .required(Form_1.default.errorMessages.name.required),
                position: yup.string()
                    .required(Form_1.default.errorMessages.position.required),
            }),
            // step 2
            yup.object().shape({
                files: yup.array()
                    .test('required', Form_1.default.errorMessages.files.required, function (files) {
                    return files.length > 0;
                })
                    .test('fileSize', Form_1.default.errorMessages.files.size, function (files) {
                    var valid = true;
                    files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                        var size = file.size / 1024 / 1024;
                        if (size > 10)
                            valid = false;
                    });
                    return valid;
                })
                    .test('fileType', Form_1.default.errorMessages.files.type, function (files) {
                    var valid = true;
                    files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                        var type = file.type;
                        if (!Form_1.default.allowedFileTypes.includes(type))
                            valid = false;
                    });
                    return valid;
                })
            }),
            // step 3
            yup.object().shape({
                phone: yup.string()
                    .matches(/^[0-9()\-+/ ]*$/g, Form_1.default.errorMessages.phone.syntax),
                email: yup.string()
                    .email(Form_1.default.errorMessages.email.email)
                    .required(Form_1.default.errorMessages.email.required),
            }),
            // step 4
            yup.object().shape({
                entryDate: yup.date()
                    .typeError(Form_1.default.errorMessages.entryDate.required)
                    .min(new Date(), Form_1.default.errorMessages.entryDate.min)
                    .required(Form_1.default.errorMessages.entryDate.required),
                dataPrivacy: yup.boolean()
                    .default(false)
                    .oneOf([true], Form_1.default.errorMessages.dataPrivacy.required)
                    .required(Form_1.default.errorMessages.dataPrivacy.required)
            })
        ];
    };
    Application.getValues = function () {
        return [
            // step 1
            {
                name: Form_1.default.getValue('name'),
                position: Form_1.default.getValue('position'),
            },
            // step 2
            {
                files: Form_1.default.getFiles('files'),
            },
            // step 3
            {
                phone: Form_1.default.getValue('phone'),
                email: Form_1.default.getValue('email'),
            },
            // step 4
            {
                entryDate: Form_1.default.getValue('entryDate'),
                dataPrivacy: Form_1.default.getChecked('dataPrivacy'),
            }
        ];
    };
    return Application;
}());
exports.default = Application;
